import { styled } from '@linaria/react';
import { memo, useMemo } from 'react';
import type { SearchResultEntry, SearchResultEntryWithType, Settings } from '../../../../types/state';
import { SettingsType } from '../../../constants/enums';
import SearchResult from './SearchResult';
import SearchResultAlt from './SearchResultAlt';
import "./RenderRecommendationsResult.linaria.module.css!=!./RenderRecommendationsResult?./RenderRecommendationsResult.linaria.module.css?css=H4sIAAAAAAAAA9NLMcxPyzDPL6lOLi0qzi+yKsjPzCtJLbIuSExJycxL1y3JL7AyKaiA85PyS0ryc1GEclLTSlAEijLTMyAitVwA6ipIGmEAAAA="
const DivRoot = /*#__PURE__*/styled('div')({
  name: "DivRoot",
  class: "d1ofh7ot",
  propsAsIs: false
});
interface RenderRecommendationsProps {
  activeID?: number; // not currently used
  cellWidth: number;
  darkMode: boolean;
  isMobile: boolean;
  model: SearchResultEntry | SearchResultEntryWithType;
  onHover?: (id: number, wipe?: boolean) => void; // not currently used
  onOpenMenu: (slug: string, options?: any) => void;
  onOpenRoom: (slug: string) => void;
  onTagClick?(tag: string): void;
  searchString: string;
  settings: Settings[SettingsType.DEFAULT];
  altDisplay?: boolean;
  source: string;
}
const RenderRecommendationsResult = memo((props: RenderRecommendationsProps) => {
  const {
    altDisplay,
    cellWidth,
    darkMode,
    isMobile,
    model,
    onTagClick,
    onOpenMenu,
    onOpenRoom,
    searchString,
    settings,
    source
  } = props;
  const resolvedSource = source || (model as SearchResultEntryWithType)?.type;
  // combined (home page) results carry every list the model matched
  const modelTypes = (model as SearchResultEntryWithType)?.types;
  const resolvedSources = useMemo(() => modelTypes || (resolvedSource ? [resolvedSource] : []), [modelTypes, resolvedSource]);
  const ResolvedSearchResult = altDisplay ? SearchResultAlt : SearchResult;
  if (!model?.id) {
    return null;
  }
  return <DivRoot>
                <ResolvedSearchResult id={model.id} darkMode={darkMode} isMobile={isMobile} onOpenMenu={onOpenMenu} onOpenRoom={onOpenRoom} onTagClick={onTagClick} searchString={searchString} settings={settings} source={resolvedSource} sources={resolvedSources} cellWidth={cellWidth} />
            </DivRoot>;
});
export default RenderRecommendationsResult;